import React from 'react'
import PropTypes from 'prop-types'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import ImageTab1Desktop from 'assets/illustrations/landing-tab-provider-management-d.svg'
import ImageTab1Mobile from 'assets/illustrations/landing-tab-provider-management-m.svg'
import ImageTab2Desktop from 'assets/illustrations/landing-tab-provider-search-d.svg'
import ImageTab2Mobile from 'assets/illustrations/landing-tab-provider-search-m.svg'
import ImageTab3Desktop from 'assets/illustrations/landing-tab-notifications-d.svg'
import ImageTab3Mobile from 'assets/illustrations/landing-tab-notifications-m.svg'
import useStyles from './styles'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTranslation from 'hooks/useTranslations'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const LandingTabs = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  const t = useTranslation()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div className={classes.root}>
      <Tabs
        centered={!isSmall}
        variant={isSmall ? 'scrollable' : 'standard'}
        className={classes.tabs}
        value={value}
        onChange={handleChange}
        aria-label="Langing tabs"
        classes={{
          indicator: classes.indicator,
        }}
      >
        <Tab
          className={classes.tab}
          label={t('landing:tab1:heading')}
          disableRipple
          {...a11yProps(0)}
        />
        <Tab
          className={classes.tab}
          label={t('landing:tab2:heading')}
          disableRipple
          {...a11yProps(1)}
        />
        <Tab
          className={classes.tab}
          label={t('landing:tab3:heading')}
          disableRipple
          {...a11yProps(2)}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Box className={classes.tabPanel}>
          <Hidden smUp className={classes.tabPanel}>
            <img src={ImageTab1Mobile} alt={t('landing:tab1:heading')} />
          </Hidden>
          <Hidden xsDown className={classes.tabPanel}>
            <img src={ImageTab1Desktop} alt={t('landing:tab1:heading')} />
          </Hidden>
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Box className={classes.tabPanel}>
          <Hidden smUp>
            <img src={ImageTab2Mobile} alt={t('landing:tab2:heading')} />
          </Hidden>
          <Hidden xsDown>
            <img src={ImageTab2Desktop} alt={t('landing:tab2:heading')} />
          </Hidden>
        </Box>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Box className={classes.tabPanel}>
          <Hidden smUp>
            <img src={ImageTab3Mobile} alt={t('landing:tab3:heading')} />
          </Hidden>
          <Hidden xsDown>
            <img src={ImageTab3Desktop} alt={t('landing:tab3:heading')} />
          </Hidden>
        </Box>
      </TabPanel>
    </div>
  )
}

export default LandingTabs
